import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import PropTypes, { string, bool } from 'prop-types';

import Icon from 'components/icon';

const CollapsibleFilters = ({
    children,
    id,
    title,
    isExpanded = false,
    labelCollapse,
    labelExpand
}) => {
    const [stateIsExpanded, setStateIsExpanded] = useState(isExpanded);

    const labelId = `label-${id}`;
    const contentId = `content-${id}`;
    const accessibilityTitle = stateIsExpanded ? labelCollapse : labelExpand;
    const iconName = stateIsExpanded ? 'arrow-drop-up' : 'arrow-drop-down';

    const toggleState = () =>
        setStateIsExpanded(prevStateIsExpanded => !prevStateIsExpanded);

    return (
        <div className="collapsible-filters">
            <h3 className="collapsible-filters__trigger">
                <button
                    aria-controls={contentId}
                    aria-expanded={stateIsExpanded}
                    className="collapsible-filters__trigger-button"
                    id={labelId}
                    onClick={toggleState}
                    title={accessibilityTitle}
                    type="button"
                >
                    <span className="collapsible-filters__trigger-text">
                        {title}
                    </span>
                    <Icon glyph={iconName} />
                    <span className="u-sr-only">{accessibilityTitle}</span>
                </button>
            </h3>
            <AnimateHeight
                aria-labelledby={labelId}
                duration={400}
                height={stateIsExpanded ? 'auto' : 0}
                id={contentId}
            >
                <div className="collapsible-filters__content">{children}</div>
            </AnimateHeight>
        </div>
    );
};

CollapsibleFilters.propTypes = {
    children: PropTypes.node,
    id: string.isRequired,
    title: string.isRequired,
    isExpanded: bool,
    labelCollapse: string.isRequired,
    labelExpand: string.isRequired
};

export default CollapsibleFilters;
